angular.module('device-management', ['core'])
    .constant('DeviceManagementConst', {
        eventUpdate: 'device-management.updated',
        tpl: 'app/device-management/'
    })
    .factory('DeviceManagementDevice', function ($resource) {
        return $resource('/crm/api/device/:id', {id: '@id'}, {
            table: {method: 'GET', url: '/crm/api/device/table', isArray: false},
            tableStatistics: {method: 'GET', url: '/crm/api/device/table-statistics', isArray: false},
            options: {method: 'GET', url: '/crm/api/device/options', isArray: true},
            autocomplete: {method: 'GET', url: '/crm/api/device/autocomplete', isArray: true},
            models: {method: 'GET', url: '/crm/api/device/models', isArray: true},
            actions: {method: 'GET', url: '/crm/api/device/:id/actions', isArray: true},
            historicalAction: {method: 'POST', url: '/crm/api/device/:id/actions/historical'},
            bulkUpdate: {method: 'POST', url: '/crm/api/device/bulk-update'},
            updateDescription: {method: 'PUT', url: '/crm/api/device/:id/description'},
            toggleFlag: {method: 'PUT', url: '/crm/api/device/:id/flag'},
            update: {method: 'PUT'}
        })
    })
    .factory('DeviceManagementTag', function ($resource) {
        return $resource('/crm/api/device-tag/:id', {id: '@id'}, {
            update: {method: 'PUT'}
        })
    })
    .factory('DeviceManagementSimCard', function ($resource) {
        return $resource('/crm/api/sim-card/:id', {id: '@id'}, {
            table: {method: 'GET', url: '/crm/api/sim-card/table', isArray: false},
            tableStatistics: {method: 'GET', url: '/crm/api/sim-card/table-statistics', isArray: false},
            options: {method: 'GET', url: '/crm/api/sim-card/options', isArray: true},
            update: {method: 'PUT'},
            actions: {method: 'GET', url: '/crm/api/sim-card/:id/actions', isArray: true},
            bulkUpdate: {method: 'POST', url: '/crm/api/sim-card/bulk-update'},
            updateDescription: {method: 'PUT', url: '/crm/api/sim-card/:id/description'},
            toggleFlag: {method: 'PUT', url: '/crm/api/sim-card/:id/flag'},
            moveDevice: {method: 'POST', url: '/crm/api/sim-card/:id/move-device'},
            duplicate: {method: 'POST', url: '/crm/api/sim-card/:id/duplicate'},
            historicalAction: {method: 'POST', url: '/crm/api/sim-card/:id/actions/historical'}
        })
    })
    .service('DeviceManagementService', function ($rootScope, modals, toastr, FilesSimpleUploadService, DeviceManagementConst, DeviceManagementDevice, DeviceManagementTag, DeviceManagementSimCard) {
        this.deviceTypes = () => ['GPS', 'MODEM', 'ROUTER', 'OTHER']
        this.deviceStatuses = () => ['ACTIVE', 'IN_SERVICE', 'SUSPENDED', 'INACTIVE']
        this.providers = () => ['1NCE', 'PLAY', 'OTHER']
        this.simStatuses = () => ['NEW', 'ACTIVE', 'DUPLICATED', 'INACTIVE']
        this.actionTypes = () => ['DUPLICATE', 'DEVICE_ASSIGN', 'DEVICE_MOVE', 'DEVICE_UNASSIGN', 'STATUS_CHANGE', 'ICCID_CHANGE', 'GSM_NUMBER_CHANGE', 'NOTE']
        this.deviceActionTypes = () => ['INSTALLATION', 'DISMOUNT', 'RELOCATION', 'SERVICE_SUSPENSION', 'SERVICE_RESIGNATION', 'CESSION']
        this.flags = () => [1, 2, 3, 4]

        this.addDevice = () => this.editDevice({id: null, type: 'GPS', status: 'ACTIVE'})
        this.showDevice = entity => modals.open(DeviceManagementConst.tpl + 'device-show-modal.html', 'DeviceManagementDeviceShowController', angular.copy(entity), {size: 'lg'}, '$ctrl')
        this.editDevice = entity => modals.open(DeviceManagementConst.tpl + 'device-edit-modal.html', 'DeviceManagementDeviceEditController', angular.copy(entity), {size: 'lg'}, '$ctrl')
        this.historicalDeviceAction = entity => modals.open(DeviceManagementConst.tpl + 'device-historical-action-modal.html', 'DeviceManagementDeviceHistoricalActionController', angular.copy(entity), {size: 'lg'}, '$ctrl')
        this.attachDeviceFile = entity => FilesSimpleUploadService.open({type: 'DEVICE', id: entity.id}).then(() => $rootScope.$broadcast(DeviceManagementConst.eventUpdate))
        this.deleteDevice = entity => modals.confirmDelete(this.deviceIdentifier(entity), () => DeviceManagementDevice.delete({id: entity.id}).$promise.then(() => $rootScope.$broadcast(DeviceManagementConst.eventUpdate)))
        this.updateDeviceDescription = (entity, description) => updateDescription(DeviceManagementDevice, entity, description)
        this.toggleDeviceFlag = (entity, flag) => toggleFlag(DeviceManagementDevice, entity, flag)
        this.bulkDeviceClient = items => this.bulkDevice(items, 'CLIENT')
        this.bulkDeviceTags = items => this.bulkDevice(items, 'TAGS')
        this.bulkDeviceStatus = items => this.bulkDevice(items, 'STATUS')
        this.bulkDeviceFlag = items => this.bulkDevice(items, 'FLAG')
        this.bulkDevice = (items, operation) => modals.open(DeviceManagementConst.tpl + 'device-bulk-update-modal.html', 'DeviceManagementDeviceBulkUpdateController', {
            ids: idsOf(items),
            operation: operation
        }, {size: 'md'}, '$ctrl')
        this.listTags = () => modals.open(DeviceManagementConst.tpl + 'device-tag-list-modal.html', 'DeviceManagementTagListController', {}, {size: 'md'}, '$ctrl')
        this.addTag = () => this.editTag({id: null, active: true, color: '#337ab7'})
        this.editTag = entity => modals.open(DeviceManagementConst.tpl + 'device-tag-edit-modal.html', 'DeviceManagementTagEditController', angular.copy(entity), {size: 'sm'}, '$ctrl')
        this.deleteTag = entity => modals.confirmDelete(entity.name, () => DeviceManagementTag.delete({id: entity.id}).$promise.then(() => $rootScope.$broadcast(DeviceManagementConst.eventUpdate)))
        this.tagStyle = tag => tag && tag.color ? {'background-color': tag.color, 'border-color': tag.color, color: contrastColor(tag.color)} : {}
        this.clientName = client => client && client.symbol
        this.userName = user => user && firstPresent(user.fullName, compactJoin(' ', user.name, user.lastname), user.login)
        this.statusChangedByText = user => this.userName(user) ? ' przez ' + this.userName(user) : ''
        this.deviceIdentifier = device => device && (firstPresent(
            compactJoin(' / ', device.manufacturer, device.model),
            prefixed('IMEI ', device.imei),
            prefixed('SN ', device.serialNumber),
            prefixed('Biznesowy ', device.businessNumber),
            device.name,
            device.type,
            device.id ? '#' + device.id : null
        ) || 'Urządzenie')
        this.simIdentifier = simCard => simCard && (simCard.iccid || simCard.gsmNumber || ('#' + simCard.id))
        this.providerClass = provider => ({
            '1NCE': 'provider-1nce',
            PLAY: 'provider-play',
            OTHER: 'provider-other'
        })[provider] || 'provider-other'
        this.equipmentSummary = device => device && compactJoin(' / ',
            device.equipmentModel,
            device.equipmentIdentifier,
            this.clientName(device.equipmentInstaller) ? 'Instalator ' + this.clientName(device.equipmentInstaller) : null,
            device.equipmentYear ? 'Rocznik ' + device.equipmentYear : null,
            device.equipmentNotes
        )
        this.actionEquipmentSummary = (action, prefix) => action && compactJoin(' / ',
            action[prefix + 'EquipmentModel'],
            action[prefix + 'EquipmentIdentifier'],
            this.clientName(action[prefix + 'EquipmentInstaller']) ? 'Instalator ' + this.clientName(action[prefix + 'EquipmentInstaller']) : null,
            action[prefix + 'EquipmentYear'] ? 'Rocznik ' + action[prefix + 'EquipmentYear'] : null,
            action[prefix + 'EquipmentNotes']
        )
        this.hasActionEquipmentChange = action => this.actionEquipmentSummary(action, 'old') || this.actionEquipmentSummary(action, 'new')

        this.addSimCard = () => this.editSimCard({id: null, provider: 'PLAY', status: 'NEW'})
        this.editSimCard = entity => modals.open(DeviceManagementConst.tpl + 'sim-card-edit-modal.html', 'DeviceManagementSimCardEditController', angular.copy(entity), {size: 'lg'}, '$ctrl')
        this.showSimCard = entity => modals.open(DeviceManagementConst.tpl + 'sim-card-show-modal.html', 'DeviceManagementSimCardShowController', angular.copy(entity), {size: 'lg'}, '$ctrl')
        this.moveDevice = entity => modals.open(DeviceManagementConst.tpl + 'sim-card-move-device-modal.html', 'DeviceManagementSimCardMoveDeviceController', angular.copy(entity), {size: 'md'}, '$ctrl')
        this.duplicate = entity => modals.open(DeviceManagementConst.tpl + 'sim-card-duplicate-modal.html', 'DeviceManagementSimCardDuplicateController', angular.copy(entity), {size: 'md'}, '$ctrl')
        this.historicalAction = entity => modals.open(DeviceManagementConst.tpl + 'sim-card-historical-action-modal.html', 'DeviceManagementSimCardHistoricalActionController', angular.copy(entity), {size: 'lg'}, '$ctrl')
        this.attachSimCardFile = entity => FilesSimpleUploadService.open({type: 'SIM-CARD', id: entity.id}).then(() => $rootScope.$broadcast(DeviceManagementConst.eventUpdate))
        this.bulkSimStatus = items => this.bulkSim(items, 'STATUS')
        this.bulkSimFlag = items => this.bulkSim(items, 'FLAG')
        this.bulkSim = (items, operation) => modals.open(DeviceManagementConst.tpl + 'sim-card-bulk-update-modal.html', 'DeviceManagementSimCardBulkUpdateController', {
            ids: idsOf(items),
            operation: operation
        }, {size: 'sm'}, '$ctrl')
        this.deleteSimCard = entity => modals.confirmDelete(entity.iccid || entity.gsmNumber || ('#' + entity.id), () => DeviceManagementSimCard.delete({id: entity.id}).$promise.then(() => $rootScope.$broadcast(DeviceManagementConst.eventUpdate)))
        this.updateSimCardDescription = (entity, description) => updateDescription(DeviceManagementSimCard, entity, description)
        this.toggleSimCardFlag = (entity, flag) => toggleFlag(DeviceManagementSimCard, entity, flag)

        function idsOf(items) {
            return (items || []).map(item => item.id).filter(id => id != null)
        }

        function updateDescription(resource, entity, description) {
            return resource.updateDescription({id: entity.id}, {description: description}).$promise.then(result => {
                entity.description = result.description
                $rootScope.$broadcast(DeviceManagementConst.eventUpdate)
                return result
            })
        }

        function toggleFlag(resource, entity, flag) {
            const previousFlagMetadata = entity ? angular.copy(entity.flagMetadata) : null
            if (!entity || !entity.id) {
                return
            }

            return resource.toggleFlag({id: entity.id}, {flag: flag}).$promise.then(metadata => {
                entity.flagMetadata = metadata && metadata.flag != null ? metadata : null
                toastr.success("Zapisano")
                $rootScope.$broadcast(DeviceManagementConst.eventUpdate)
                return entity.flagMetadata
            }).catch(() => {
                entity.flagMetadata = previousFlagMetadata
                toastr.error("Nie udało się zapisać flagi")
            })
        }

        function firstPresent() {
            for (let i = 0; i < arguments.length; i++) {
                if (arguments[i]) {
                    return arguments[i]
                }
            }
            return null
        }

        function compactJoin(separator) {
            return Array.prototype.slice.call(arguments, 1).filter(Boolean).join(separator) || null
        }

        function prefixed(prefix, value) {
            return value ? prefix + value : null
        }

        function contrastColor(color) {
            let hex = normalizeHex(color)
            if (!hex) {
                return '#fff'
            }
            let r = parseInt(hex.substring(0, 2), 16)
            let g = parseInt(hex.substring(2, 4), 16)
            let b = parseInt(hex.substring(4, 6), 16)
            return ((r * 299 + g * 587 + b * 114) / 1000) > 150 ? '#222' : '#fff'
        }

        function normalizeHex(color) {
            if (!/^#[0-9a-fA-F]{6}$/.test(color || '')) {
                return null
            }
            return color.substring(1)
        }
    })
    .component('devicePicker', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            required: '<?',
            disabled: '<?',
            modelType: '<?',
            placeholder: '@?',
            onChange: '&?'
        },
        templateUrl: 'app/device-management/device-picker.html',
        controller: function (DeviceManagementDevice, DeviceManagementService) {
            this.DeviceManagementService = DeviceManagementService
            this.$onInit = () => {
                this.items = []
                this.modelType = this.modelType || 'object'
                this.placeholder = this.placeholder || '-- urządzenie --'
                this.ngModelCtrl.$render = () => this.setSelected(this.ngModelCtrl.$viewValue)
                this.ngModelCtrl.$formatters.push(modelValue => modelValue)
                this.ngModelCtrl.$parsers.push(viewValue => this.modelType === 'id' ? viewValue && viewValue.id : viewValue)
                this.refresh()
            }
            this.refresh = q => DeviceManagementDevice.autocomplete({q: q}).$promise.then(items => {
                this.items = this.mergeSelected(items)
                return this.items
            })
            this.setSelected = value => {
                if (!value) {
                    this.selected = null
                    return
                }
                if (this.modelType === 'id' && !angular.isObject(value)) {
                    let selected = this.findById(value)
                    if (selected) {
                        this.selected = selected
                    } else {
                        DeviceManagementDevice.get({id: value}).$promise.then(device => {
                            this.selected = device
                            this.items = this.mergeSelected(this.items)
                        })
                    }
                    return
                }
                this.selected = this.findById(value.id) || value
                this.items = this.mergeSelected(this.items)
            }
            this.onSelectionChanged = item => {
                this.selected = item || null
                this.ngModelCtrl.$setViewValue(this.selected)
                this.ngModelCtrl.$validate()
                this.ngModelCtrl.$render()
                if (angular.isFunction(this.onChange)) {
                    this.onChange({$device: this.selected})
                }
            }
            this.findById = id => (this.items || []).find(item => item.id === id)
            this.mergeSelected = items => {
                items = (items || []).slice()
                if (this.selected && !items.some(item => item.id === this.selected.id)) {
                    items.unshift(this.selected)
                }
                return items
            }
            this.clientName = device => device && device.client && device.client.symbol
            this.deviceIdentifier = device => DeviceManagementService.deviceIdentifier(device)
            this.showDevice = device => DeviceManagementService.showDevice(device)
            this.details = device => {
                if (!device) {
                    return []
                }
                return [
                    device.businessNumber ? 'Biznesowy: ' + device.businessNumber : null,
                    device.imei ? 'IMEI: ' + device.imei : null,
                    device.serialNumber ? 'SN: ' + device.serialNumber : null,
                    this.clientName(device) ? 'Klient: ' + this.clientName(device) : null
                ].filter(Boolean)
            }
        }
    })
    .component('deviceTagPicker', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            tags: '<',
            required: '<?',
            disabled: '<?',
            placeholder: '@?'
        },
        templateUrl: 'app/device-management/device-tag-picker.html',
        controller: function (DeviceManagementService, $timeout, $element) {
            this.DeviceManagementService = DeviceManagementService
            this.$onInit = () => {
                this.selected = []
                this.query = ''
                this.placeholder = this.placeholder || '-- tagi --'
                this.ngModelCtrl.$render = () => this.render()
                this.ngModelCtrl.$validators.required = () => !this.required || this.selected.length > 0
                this.render()
                this.ngModelCtrl.$validate()
            }
            this.$onChanges = () => {
                if (this.ngModelCtrl) {
                    this.syncSelectedFromOptions()
                    this.ngModelCtrl.$validate()
                }
            }
            this.render = () => {
                this.selected = this.normalizeSelected(this.ngModelCtrl.$viewValue)
                this.syncSelectedFromOptions()
            }
            this.normalizeSelected = value => (angular.isArray(value) ? value : [])
                .filter(tag => tag)
                .map(tag => this.findTag(tag.id) || tag)
                .filter((tag, index, tags) => tags.findIndex(item => this.sameTag(item, tag)) === index)
            this.syncSelectedFromOptions = () => {
                this.selected = this.normalizeSelected(this.selected)
            }
            this.filteredTags = () => {
                let query = (this.query || '').toLowerCase()
                return (this.tags || [])
                    .filter(tag => !query || (tag.name || '').toLowerCase().indexOf(query) !== -1)
                    .sort((left, right) => (left.name || '').localeCompare(right.name || ''))
            }
            this.toggleOpen = event => {
                if (event) {
                    event.preventDefault()
                    event.stopPropagation()
                }
                if (!this.disabled) {
                    this.open = !this.open
                    if (this.open) {
                        this.focusSearch()
                    }
                }
            }
            this.onControlKeydown = event => {
                if (this.disabled) {
                    return
                }
                if ([13, 32, 40].indexOf(event.which) !== -1) {
                    this.toggleOpen(event)
                }
                if (event.which === 27) {
                    this.open = false
                }
            }
            this.toggleTag = (tag, event) => {
                if (event) {
                    event.preventDefault()
                    event.stopPropagation()
                }
                if (this.disabled) {
                    return
                }
                let index = this.selected.findIndex(selected => this.sameTag(selected, tag))
                if (index >= 0) {
                    this.selected.splice(index, 1)
                } else {
                    this.selected.push(tag)
                }
                this.updateModel()
            }
            this.selectAll = (tags, event) => {
                if (event) {
                    event.preventDefault()
                    event.stopPropagation()
                }
                if (this.disabled) {
                    return
                }
                let selectableTags = tags || []
                selectableTags.forEach(tag => {
                    if (!this.isSelected(tag)) {
                        this.selected.push(tag)
                    }
                })
                this.updateModel()
            }
            this.removeTag = (tag, event) => {
                if (event) {
                    event.preventDefault()
                    event.stopPropagation()
                }
                if (this.disabled) {
                    return
                }
                this.selected = this.selected.filter(selected => !this.sameTag(selected, tag))
                this.updateModel()
            }
            this.clear = event => {
                if (event) {
                    event.preventDefault()
                    event.stopPropagation()
                }
                if (!this.disabled) {
                    this.selected = []
                    this.updateModel()
                }
            }
            this.listTags = event => {
                if (event) {
                    event.preventDefault()
                    event.stopPropagation()
                }
                this.open = false
                DeviceManagementService.listTags()
            }
            this.updateModel = () => {
                this.selected = this.normalizeSelected(this.selected)
                this.ngModelCtrl.$setViewValue(this.selected)
                this.ngModelCtrl.$validate()
            }
            this.isSelected = tag => this.selected.some(selected => this.sameTag(selected, tag))
            this.allSelected = tags => (tags || []).length > 0 && (tags || []).every(tag => this.isSelected(tag))
            this.focusSearch = () => $timeout(() => {
                let input = $element[0].querySelector('.device-tag-picker__search-input')
                if (input) {
                    input.focus()
                    input.select()
                }
            })
            this.findTag = id => (this.tags || []).find(tag => tag.id === id)
            this.sameTag = (left, right) => left && right && left.id === right.id
        }
    })
    .controller('DeviceManagementDeviceEditController', function (toastr, $q, $scope, $rootScope, $uibModalInstance, data, DeviceManagementConst, DeviceManagementService, DeviceManagementDevice, DeviceManagementTag, DeviceManagementSimCard) {
        this.DeviceManagementService = DeviceManagementService
        this.$onInit = () => {
            this.item = data
            this.simCards = []
            this.allSimCards = []
            this.originalSimCard = null
            this.selectedSimCard = null
            this.simCardSelectionTouched = false
            this.ensureTags()
            this.loadTags()
            this.loadSimCards()
            if (this.item.id) {
                this.load()
            }
        }
        this.load = () => {
            DeviceManagementDevice.get({id: this.item.id}).$promise.then(result => {
                this.item = result
                this.ensureTags()
                this.loadSimCards()
            })
            DeviceManagementDevice.actions({id: this.item.id}).$promise.then(result => this.actions = result)
        }
        this.loadTags = () => DeviceManagementTag.query().$promise.then(result => this.tags = result.filter(tag => tag.active || this.hasTag(tag)))
        this.loadSimCards = () => {
            DeviceManagementSimCard.options().$promise.then(result => {
                this.allSimCards = result || []
                this.simCards = this.item.id ? this.allSimCards.filter(card => this.isCurrentDevice(card.device)) : []
                this.syncSelectedSimCard()
            })
        }
        this.syncSelectedSimCard = () => {
            this.originalSimCard = this.simCards.find(card => card.status === 'ACTIVE') || null
            if (!this.simCardSelectionTouched) {
                this.selectedSimCard = this.originalSimCard
            }
        }
        this.availableSimCards = () => (this.allSimCards || [])
            .filter(card => card.status === 'ACTIVE')
            .filter(card => !card.device || this.isCurrentDevice(card.device) || this.sameSimCard(card, this.selectedSimCard))
        this.onSimCardSelectionChanged = () => this.simCardSelectionTouched = true
        this.isCurrentDevice = device => device && this.item && this.item.id && device.id === this.item.id
        this.sameSimCard = (left, right) => !!left && !!right && left.id === right.id
        this.ensureTags = () => this.item.tags = this.item.tags || []
        this.hasTag = tag => this.item.tags && this.item.tags.some(selected => selected.id === tag.id)
        this.splitTags = value => value ? value.split(',') : []
        this.addAction = () => DeviceManagementService.historicalDeviceAction(this.item)
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            this.item.name = DeviceManagementService.deviceIdentifier(this.item)
            let promise = this.item.id ? DeviceManagementDevice.update(this.item).$promise : DeviceManagementDevice.save(this.item).$promise
            return promise.then(result => this.syncSimCardAssignment(result).then(() => {
                $rootScope.$broadcast(DeviceManagementConst.eventUpdate)
                $uibModalInstance.close(result)
                toastr.success('Zapisano')
                return result
            }))
        }
        this.syncSimCardAssignment = device => {
            if (this.sameSimCard(this.originalSimCard, this.selectedSimCard)) {
                return $q.when()
            }

            let steps = []
            if (this.originalSimCard) {
                steps.push(() => DeviceManagementSimCard.moveDevice({id: this.originalSimCard.id}, {
                    actionDate: new Date(),
                    newDevice: null,
                    reason: 'Zmiana przypisania w formularzu urządzenia'
                }).$promise)
            }
            if (this.selectedSimCard) {
                steps.push(() => DeviceManagementSimCard.moveDevice({id: this.selectedSimCard.id}, {
                    actionDate: new Date(),
                    newDevice: device,
                    reason: 'Zmiana przypisania w formularzu urządzenia'
                }).$promise)
            }

            return steps.reduce((promise, step) => promise.then(step), $q.when())
        }
        $scope.$on(DeviceManagementConst.eventUpdate, () => {
            this.loadTags()
            this.loadSimCards()
        })
    })
    .controller('DeviceManagementDeviceShowController', function ($scope, $uibModalInstance, data, DeviceManagementConst, DeviceManagementService, DeviceManagementDevice, DeviceManagementSimCard) {
        this.DeviceManagementService = DeviceManagementService
        this.$onInit = () => {
            this.item = data
            this.simCards = []
            this.flags = DeviceManagementService.flags()
            this.ensureTags()
            this.load()
        }
        this.load = () => {
            DeviceManagementDevice.get({id: this.item.id}).$promise.then(result => {
                this.item = result
                this.ensureTags()
                this.loadSimCards()
            })
            DeviceManagementDevice.actions({id: this.item.id}).$promise.then(result => this.actions = result)
        }
        this.loadSimCards = () => DeviceManagementSimCard.options().$promise.then(result => {
            this.simCards = result.filter(card => card.device && card.device.id === this.item.id)
        })
        this.ensureTags = () => this.item.tags = this.item.tags || []
        this.splitTags = value => value ? value.split(',') : []
        this.addAction = () => DeviceManagementService.historicalDeviceAction(this.item)
        this.attachFile = () => DeviceManagementService.attachDeviceFile(this.item)
        this.deleteDevice = () => DeviceManagementService.deleteDevice(this.item)
        this.toggleFlag = flag => DeviceManagementService.toggleDeviceFlag(this.item, flag)
        this.cancel = () => $uibModalInstance.dismiss()
        this.edit = () => {
            let item = angular.copy(this.item)
            $uibModalInstance.dismiss()
            DeviceManagementService.editDevice(item)
        }
        $scope.$on(DeviceManagementConst.eventUpdate, () => this.load())
    })
    .controller('DeviceManagementDeviceHistoricalActionController', function (toastr, $rootScope, $uibModalInstance, data, DeviceManagementConst, DeviceManagementService, DeviceManagementDevice) {
        this.DeviceManagementService = DeviceManagementService
        this.$onInit = () => {
            this.item = data
            this.form = {
                type: 'INSTALLATION',
                actionDate: new Date(),
                updateEquipment: true,
                equipmentModel: data.equipmentModel,
                equipmentIdentifier: data.equipmentIdentifier,
                equipmentInstaller: data.equipmentInstaller,
                equipmentYear: data.equipmentYear,
                equipmentNotes: data.equipmentNotes
            }
        }
        this.onTypeChanged = () => {
            if (this.form.type === 'DISMOUNT') {
                this.form.updateEquipment = true
                this.form.equipmentModel = null
                this.form.equipmentIdentifier = null
                this.form.equipmentInstaller = null
                this.form.equipmentYear = null
                this.form.equipmentNotes = null
            }
            if (this.form.type === 'INSTALLATION' || this.form.type === 'RELOCATION') {
                this.form.updateEquipment = true
            }
            if (this.form.type === 'SERVICE_SUSPENSION' || this.form.type === 'SERVICE_RESIGNATION' || this.form.type === 'CESSION') {
                this.form.updateEquipment = false
            }
        }
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            let promise = DeviceManagementDevice.historicalAction({id: this.item.id}, this.form).$promise
            promise.then(() => {
                $rootScope.$broadcast(DeviceManagementConst.eventUpdate)
                $uibModalInstance.close()
                toastr.success('Zapisano')
            })
            return promise
        }
    })
    .controller('DeviceManagementDeviceBulkUpdateController', function (toastr, $scope, $rootScope, $uibModalInstance, data, DeviceManagementConst, DeviceManagementService, DeviceManagementDevice, DeviceManagementTag) {
        this.DeviceManagementService = DeviceManagementService
        this.$onInit = () => {
            this.operation = data.operation
            this.form = {
                ids: data.ids || [],
                tags: []
            }
            if (this.operation === 'TAGS') {
                this.loadTags()
            }
        }
        this.loadTags = () => DeviceManagementTag.query().$promise.then(result => this.tags = result.filter(tag => tag.active || this.hasTag(tag)))
        this.hasTag = tag => this.form.tags && this.form.tags.some(selected => selected.id === tag.id)
        this.title = () => ({
            CLIENT: 'Przypisz klienta',
            TAGS: 'Dodaj tagi',
            STATUS: 'Zmień status',
            FLAG: 'Ustaw flagę'
        })[this.operation]
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            let form = {
                ids: this.form.ids,
                updateClient: this.operation === 'CLIENT',
                client: this.form.client,
                updateStatus: this.operation === 'STATUS',
                status: this.form.status,
                addTags: this.operation === 'TAGS',
                tags: this.form.tags,
                updateFlag: this.operation === 'FLAG',
                flag: this.form.flag,
                comment: this.form.comment
            }
            let promise = DeviceManagementDevice.bulkUpdate(form).$promise
            promise.then(() => {
                $rootScope.$broadcast(DeviceManagementConst.eventUpdate)
                $uibModalInstance.close()
                toastr.success('Zapisano')
            })
            return promise
        }
        $scope.$on(DeviceManagementConst.eventUpdate, () => {
            if (this.operation === 'TAGS') {
                this.loadTags()
            }
        })
    })
    .controller('DeviceManagementTagListController', function ($scope, $uibModalInstance, DeviceManagementConst, DeviceManagementService, DeviceManagementTag) {
        this.DeviceManagementService = DeviceManagementService
        this.$onInit = () => this.load()
        this.load = () => DeviceManagementTag.query().$promise.then(result => this.tags = result)
        this.cancel = () => $uibModalInstance.dismiss()
        $scope.$on(DeviceManagementConst.eventUpdate, () => this.load())
    })
    .controller('DeviceManagementTagEditController', function (toastr, $rootScope, $uibModalInstance, data, DeviceManagementConst, DeviceManagementService, DeviceManagementTag) {
        this.DeviceManagementService = DeviceManagementService
        this.colorPresets = [
            {value: '#337ab7', className: 'blue'},
            {value: '#5cb85c', className: 'green'},
            {value: '#f0ad4e', className: 'orange'},
            {value: '#d9534f', className: 'red'},
            {value: '#5bc0de', className: 'cyan'},
            {value: '#6c43bf', className: 'purple'},
            {value: '#29abe2', className: 'nce-blue'},
            {value: '#777777', className: 'gray'}
        ]
        this.$onInit = () => {
            this.item = data
            this.item.color = this.item.color || this.colorPresets[0].value
            this.item.active = this.item.active !== false
        }
        this.setColor = color => this.item.color = color
        this.previewTag = () => ({
            name: this.item.name || 'Przykładowy tag',
            color: this.item.color
        })
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            let promise = this.item.id ? DeviceManagementTag.update(this.item).$promise : DeviceManagementTag.save(this.item).$promise
            promise.then(result => {
                $rootScope.$broadcast(DeviceManagementConst.eventUpdate)
                $uibModalInstance.close(result)
                toastr.success('Zapisano')
            })
            return promise
        }
    })
    .controller('DeviceManagementSimCardEditController', function (toastr, $rootScope, $uibModalInstance, data, DeviceManagementConst, DeviceManagementService, DeviceManagementSimCard) {
        this.DeviceManagementService = DeviceManagementService
        this.$onInit = () => {
            this.item = data
        }
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            let promise = this.item.id ? DeviceManagementSimCard.update(this.item).$promise : DeviceManagementSimCard.save(this.item).$promise
            promise.then(result => {
                $rootScope.$broadcast(DeviceManagementConst.eventUpdate)
                $uibModalInstance.close(result)
                toastr.success('Zapisano')
            })
            return promise
        }
    })
    .controller('DeviceManagementSimCardShowController', function ($scope, $uibModalInstance, data, DeviceManagementSimCard, DeviceManagementConst, DeviceManagementService) {
        this.DeviceManagementService = DeviceManagementService
        this.$onInit = () => {
            this.item = data
            this.flags = DeviceManagementService.flags()
            this.load()
        }
        this.load = () => {
            DeviceManagementSimCard.get({id: this.item.id}).$promise.then(result => this.item = result)
            DeviceManagementSimCard.actions({id: this.item.id}).$promise.then(result => this.actions = result)
        }
        this.hasDuplicateData = () => this.item && (this.item.replacedBy || this.item.replacedAt)
        this.addAction = () => DeviceManagementService.historicalAction(this.item)
        this.attachFile = () => DeviceManagementService.attachSimCardFile(this.item)
        this.moveDevice = () => DeviceManagementService.moveDevice(this.item)
        this.duplicate = () => DeviceManagementService.duplicate(this.item)
        this.deleteSimCard = () => DeviceManagementService.deleteSimCard(this.item)
        this.toggleFlag = flag => DeviceManagementService.toggleSimCardFlag(this.item, flag)
        this.cancel = () => $uibModalInstance.dismiss()
        this.edit = () => {
            let item = angular.copy(this.item)
            $uibModalInstance.dismiss()
            DeviceManagementService.editSimCard(item)
        }
        $scope.$on(DeviceManagementConst.eventUpdate, () => this.load())
    })
    .controller('DeviceManagementSimCardMoveDeviceController', function (toastr, $rootScope, $uibModalInstance, data, DeviceManagementConst, DeviceManagementSimCard) {
        this.$onInit = () => {
            this.item = data
            this.form = {
                actionDate: new Date(),
                historical: false,
                oldDevice: data.device
            }
        }
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            let promise = DeviceManagementSimCard.moveDevice({id: this.item.id}, this.form).$promise
            promise.then(() => {
                $rootScope.$broadcast(DeviceManagementConst.eventUpdate)
                $uibModalInstance.close()
                toastr.success('Zapisano')
            })
            return promise
        }
    })
    .controller('DeviceManagementSimCardDuplicateController', function (toastr, $rootScope, $uibModalInstance, data, DeviceManagementConst, DeviceManagementSimCard) {
        this.$onInit = () => {
            this.item = data
            this.form = {
                actionDate: new Date()
            }
            DeviceManagementSimCard.options().$promise.then(result => {
                this.newCards = result.filter(card => card.status === 'NEW' && card.id !== this.item.id && card.provider === this.item.provider)
            })
        }
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            let promise = DeviceManagementSimCard.duplicate({id: this.item.id}, this.form).$promise
            promise.then(() => {
                $rootScope.$broadcast(DeviceManagementConst.eventUpdate)
                $uibModalInstance.close()
                toastr.success('Zapisano')
            })
            return promise
        }
    })
    .controller('DeviceManagementSimCardHistoricalActionController', function (toastr, $rootScope, $uibModalInstance, data, DeviceManagementConst, DeviceManagementService, DeviceManagementSimCard) {
        this.DeviceManagementService = DeviceManagementService
        this.$onInit = () => {
            this.item = data
            this.form = {
                type: 'DEVICE_MOVE',
                actionDate: new Date()
            }
            DeviceManagementSimCard.options().$promise.then(result => this.simCards = result.filter(card => card.id !== this.item.id))
        }
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            let promise = DeviceManagementSimCard.historicalAction({id: this.item.id}, this.form).$promise
            promise.then(() => {
                $rootScope.$broadcast(DeviceManagementConst.eventUpdate)
                $uibModalInstance.close()
                toastr.success('Zapisano')
            })
            return promise
        }
    })
    .controller('DeviceManagementSimCardBulkUpdateController', function (toastr, $rootScope, $uibModalInstance, data, DeviceManagementConst, DeviceManagementService, DeviceManagementSimCard) {
        this.DeviceManagementService = DeviceManagementService
        this.$onInit = () => {
            this.operation = data.operation || 'STATUS'
            this.form = {ids: data.ids || []}
        }
        this.title = () => ({
            STATUS: 'Zmień status',
            FLAG: 'Ustaw flagę'
        })[this.operation]
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            let form = {
                ids: this.form.ids,
                updateStatus: this.operation === 'STATUS',
                status: this.form.status,
                updateFlag: this.operation === 'FLAG',
                flag: this.form.flag,
                comment: this.form.comment
            }
            let promise = DeviceManagementSimCard.bulkUpdate(form).$promise
            promise.then(() => {
                $rootScope.$broadcast(DeviceManagementConst.eventUpdate)
                $uibModalInstance.close()
                toastr.success('Zapisano')
            })
            return promise
        }
    })
    .component('deviceManagementDeviceBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<',
            showPreviewAction: '<',
            onEdit: '&?',
            onAddAction: '&?',
            onAttachFile: '&?',
            onDelete: '&?',
            onToggleFlag: '&?'
        },
        templateUrl: 'app/device-management/device-btn-options.html',
        controller: function (DeviceManagementService) {
            this.$onInit = () => {
                this.flags = DeviceManagementService.flags()
                this.showPreviewAction = this.showPreviewAction !== false
            }
            this.call = (callback, fallback) => angular.isFunction(callback) ? callback() : fallback()
            this.show = () => DeviceManagementService.showDevice(this.item)
            this.edit = () => this.call(this.onEdit, () => DeviceManagementService.editDevice(this.item))
            this.addAction = () => this.call(this.onAddAction, () => DeviceManagementService.historicalDeviceAction(this.item))
            this.attachFile = () => this.call(this.onAttachFile, () => DeviceManagementService.attachDeviceFile(this.item))
            this.deleteDevice = () => this.call(this.onDelete, () => DeviceManagementService.deleteDevice(this.item))
            this.toggleFlag = flag => angular.isFunction(this.onToggleFlag) ? this.onToggleFlag({flag: flag}) : DeviceManagementService.toggleDeviceFlag(this.item, flag)
        }
    })
    .component('deviceManagementSimCardBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<',
            showPreviewAction: '<',
            onEdit: '&?',
            onAddAction: '&?',
            onAttachFile: '&?',
            onMoveDevice: '&?',
            onDuplicate: '&?',
            onDelete: '&?',
            onToggleFlag: '&?'
        },
        templateUrl: 'app/device-management/sim-card-btn-options.html',
        controller: function (DeviceManagementService) {
            this.$onInit = () => {
                this.flags = DeviceManagementService.flags()
                this.showPreviewAction = this.showPreviewAction !== false
            }
            this.call = (callback, fallback) => angular.isFunction(callback) ? callback() : fallback()
            this.show = () => DeviceManagementService.showSimCard(this.item)
            this.edit = () => this.call(this.onEdit, () => DeviceManagementService.editSimCard(this.item))
            this.addAction = () => this.call(this.onAddAction, () => DeviceManagementService.historicalAction(this.item))
            this.attachFile = () => this.call(this.onAttachFile, () => DeviceManagementService.attachSimCardFile(this.item))
            this.moveDevice = () => this.call(this.onMoveDevice, () => DeviceManagementService.moveDevice(this.item))
            this.duplicate = () => this.call(this.onDuplicate, () => DeviceManagementService.duplicate(this.item))
            this.deleteSimCard = () => this.call(this.onDelete, () => DeviceManagementService.deleteSimCard(this.item))
            this.toggleFlag = flag => angular.isFunction(this.onToggleFlag) ? this.onToggleFlag({flag: flag}) : DeviceManagementService.toggleSimCardFlag(this.item, flag)
        }
    })
    .component('deviceManagementDeviceList', {
        bindings: {
            page: '<',
            filters: '<',
            statistics: '<'
        },
        templateUrl: 'app/device-management/device-list.html',
        controller: function ($q, $scope, DeviceManagementConst, DeviceManagementService, DeviceManagementDevice, DeviceManagementTag, TableSelection) {
            this.DeviceManagementService = DeviceManagementService
            this.$onInit = () => {
                this.selection = TableSelection.create(this.page.list)
                this.models = []
                this.tags = []
                this.flags = this.DeviceManagementService.flags()
                this.initFilters()
                DeviceManagementDevice.models().$promise.then(result => this.models = result)
                DeviceManagementTag.query().$promise.then(result => this.tags = result)
            }
            this.initFilters = () => {
                this.filters = this.filters || {}
                this.filters.status = this.normalizeArray(this.filters.status)
                this.filters.type = this.normalizeArray(this.filters.type)
                this.filters.tag = this.normalizeArray(this.filters.tag).map(id => parseInt(id, 10)).filter(id => !isNaN(id))
                this.filters.model = this.normalizeArray(this.filters.model)
                this.filters.flags = this.normalizeArray(this.filters.flags).map(id => parseInt(id, 10)).filter(id => !isNaN(id))
                this.statusStatistics = this.fillStatusStatistics(this.statistics, this.DeviceManagementService.deviceStatuses())
            }
            this.normalizeArray = value => {
                if (angular.isArray(value)) {
                    return value.filter(item => item !== null && item !== undefined && item !== '')
                }
                return value === null || value === undefined || value === '' ? [] : [value]
            }
            this.reset = () => {
                this.filters = {status: []}
            }
            this.fillStatusStatistics = (statistics, statuses) => {
                let result = statistics || {status: {}}
                result.status = result.status || {}
                statuses.forEach(status => {
                    if (!angular.isNumber(result.status[status])) {
                        result.status[status] = 0
                    }
                })
                return result
            }
            this.simCardsFor = device => device && device.simCards ? device.simCards : []
            this.reload = () => {
                let params = angular.copy(this.filters || {})
                this.selection.selectNone()
                return $q.all([
                    DeviceManagementDevice.table(params).$promise,
                    DeviceManagementDevice.tableStatistics(params).$promise
                ]).then(result => {
                    this.page = result[0]
                    this.statistics = result[1]
                    this.selection.setItems(this.page.list)
                    this.statusStatistics = this.fillStatusStatistics(this.statistics, this.DeviceManagementService.deviceStatuses())
                })
            }
            $scope.$on(DeviceManagementConst.eventUpdate, () => this.reload())
        }
    })
    .component('deviceManagementSimCardList', {
        bindings: {
            page: '<',
            filters: '<',
            statistics: '<'
        },
        templateUrl: 'app/device-management/sim-card-list.html',
        controller: function ($q, $scope, DeviceManagementConst, DeviceManagementService, DeviceManagementSimCard, TableSelection) {
            this.DeviceManagementService = DeviceManagementService
            this.missingFieldOptions = [
                {value: 'WITHOUT_ICCID', label: 'Bez ICCID', icon: 'fa-barcode', param: 'withoutIccid'},
                {value: 'WITHOUT_DEVICE', label: 'Bez urządzenia', icon: 'fa-microchip', param: 'withoutDevice'}
            ]
            this.$onInit = () => {
                this.selection = TableSelection.create(this.page.list)
                this.flags = this.DeviceManagementService.flags()
                this.initFilters()
                this.initMissingFields()
            }
            this.$onChanges = () => {
                this.initFilters()
                this.initMissingFields()
            }
            this.reset = () => {
                this.filters = {status: []}
                this.missingFields = []
            }
            this.initFilters = () => {
                this.filters = this.filters || {}
                this.filters.status = this.normalizeArray(this.filters.status)
                this.filters.flags = this.normalizeArray(this.filters.flags).map(id => parseInt(id, 10)).filter(id => !isNaN(id))
                this.statusStatistics = this.fillStatusStatistics(this.statistics, this.DeviceManagementService.simStatuses())
            }
            this.normalizeArray = value => {
                if (angular.isArray(value)) {
                    return value.filter(item => item !== null && item !== undefined && item !== '')
                }
                return value === null || value === undefined || value === '' ? [] : [value]
            }
            this.fillStatusStatistics = (statistics, statuses) => {
                let result = statistics || {status: {}}
                result.status = result.status || {}
                statuses.forEach(status => {
                    if (!angular.isNumber(result.status[status])) {
                        result.status[status] = 0
                    }
                })
                return result
            }
            this.initMissingFields = () => {
                this.filters = this.filters || {}
                this.missingFields = this.missingFieldOptions
                    .filter(option => this.isFilterEnabled(this.filters[option.param]))
                    .map(option => option.value)
            }
            this.searchMissingFields = (filters, search) => {
                filters = this.syncMissingFieldFilters(filters)
                search(filters)
            }
            this.syncMissingFieldFilters = filters => {
                filters = filters || (this.filters = {})
                this.missingFieldOptions.forEach(option => filters[option.param] = this.hasMissingField(option.value) || null)
                return filters
            }
            this.hasMissingField = value => (this.missingFields || []).indexOf(value) !== -1
            this.isFilterEnabled = value => value === true || value === 'true'
            this.reload = () => {
                let params = this.syncMissingFieldFilters(angular.copy(this.filters || {}))
                this.selection.selectNone()
                return $q.all([
                    DeviceManagementSimCard.table(params).$promise,
                    DeviceManagementSimCard.tableStatistics(params).$promise
                ]).then(result => {
                    this.page = result[0]
                    this.statistics = result[1]
                    this.selection.setItems(this.page.list)
                    this.statusStatistics = this.fillStatusStatistics(this.statistics, this.DeviceManagementService.simStatuses())
                })
            }
            $scope.$on(DeviceManagementConst.eventUpdate, () => this.reload())
        }
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: 'ROLE_DEVICE_SIM_MANAGEMENT',
            featureToggle: 'DEVICE_SIM_MANAGEMENT',
            path: '/device-management/sim-cards',
            ico: 'fa fa-fw fa-microchip',
            name: 'device-management.menu',
            order: 103
        })
    })
    .config(function ($stateProvider) {
        $stateProvider
            .state('deviceManagementSimCardList', {
                parent: 'app',
                url: '/device-management/sim-cards?{page:int}&{size:int}&sort&search&provider&status&flags&device&{withoutIccid:boolean}&{withoutDevice:boolean}',
                data: {
                    authorities: ['ROLE_DEVICE_SIM_MANAGEMENT'],
                    featureToggle: 'DEVICE_SIM_MANAGEMENT'
                },
                params: {
                    status: {array: true, squash: false},
                    flags: {array: true, value: [], squash: false, type: "int"}
                },
                views: {
                    'content@': 'deviceManagementSimCardList'
                },
                resolve: {
                    filters: $stateParams => angular.copy($stateParams),
                    page: (DeviceManagementSimCard, $stateParams) => DeviceManagementSimCard.table(angular.copy($stateParams)).$promise,
                    statistics: (DeviceManagementSimCard, $stateParams) => DeviceManagementSimCard.tableStatistics(angular.copy($stateParams)).$promise
                }
            })
            .state('deviceManagementDeviceList', {
                parent: 'app',
                url: '/device-management/devices?{page:int}&{size:int}&sort&search&type&status&tag&model&flags',
                data: {
                    authorities: ['ROLE_DEVICE_SIM_MANAGEMENT'],
                    featureToggle: 'DEVICE_SIM_MANAGEMENT'
                },
                params: {
                    status: {array: true, squash: false},
                    type: {array: true, squash: false},
                    tag: {array: true, squash: false},
                    model: {array: true, squash: false},
                    flags: {array: true, value: [], squash: false, type: "int"}
                },
                views: {
                    'content@': 'deviceManagementDeviceList'
                },
                resolve: {
                    filters: $stateParams => angular.copy($stateParams),
                    page: (DeviceManagementDevice, $stateParams) => DeviceManagementDevice.table(angular.copy($stateParams)).$promise,
                    statistics: (DeviceManagementDevice, $stateParams) => DeviceManagementDevice.tableStatistics(angular.copy($stateParams)).$promise
                }
            })
    })
